import type { IconName } from "@nnf3d/svgs";

import iconSprite from "../assets/svgs/icon-sprite.svg";
import type { VoidComponent } from "../lib/types";

interface Props extends React.SVGProps<SVGSVGElement> {
	name: IconName;
	title?: string;
	className?: string;
}

const Icon: VoidComponent<Props> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		data-name={props.name}
		className={props.className}
		fill="currentColor"
		{...props}
	>
		<title>{props.title ?? props.name}</title>

		<use href={`${iconSprite}#${props.name}`} />
	</svg>
);

export { Icon };
